/* eslint-disable @typescript-eslint/unbound-method */
import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import type {
  FavoriteItemType,
  FavoritesOptionsStateType,
  FavoritesStateType,
} from './types';

export const favoritesAdapter = createEntityAdapter<FavoriteItemType>({
  sortComparer: (a, b) => b.addedBy - a.addedBy,
});

const favoritesInitialState: FavoritesStateType = {
  ...favoritesAdapter.getInitialState(),
  isIrrelevant: false,
  options: {
    offset: 0,
    limit: 12,
    sort: ['price'],
  },
};

export const favoritesSlice = createSlice({
  name: 'favorites',
  initialState: favoritesInitialState,
  reducers: {
    addItem: favoritesAdapter.addOne,
    removeItem: favoritesAdapter.removeOne,
    removeAllItems: favoritesAdapter.removeAll,
    actualizeItems: (state, action: PayloadAction<FavoriteItemType['id'][]>) => {
      const outdatedItems = state.ids.filter(id => !action.payload.includes(id));

      if (outdatedItems.length > 0) {
        favoritesAdapter.removeMany(state, outdatedItems);
        state.isIrrelevant = true;
      }
    },
    setOffset: (state, action: PayloadAction<FavoritesOptionsStateType['offset']>) => {
      state.options.offset = action.payload;
    },
    setLimit: (state, action: PayloadAction<FavoritesOptionsStateType['limit']>) => {
      state.options.limit = action.payload;
    },
    setSort: (state, action: PayloadAction<FavoritesOptionsStateType['sort']>) => {
      state.options.sort = action.payload;
    },
    setIrrelevant: (state, action: PayloadAction<FavoritesStateType['isIrrelevant']>) => {
      state.isIrrelevant = action.payload;
    },
  },
});

export const favoritesSelectors = favoritesAdapter.getSelectors();

export default persistReducer(
  {
    key: 'favorites',
    version: 1,
    storage,
    blacklist: ['options', 'isIrrelevant'],
  },
  favoritesSlice.reducer,
);
